/**
 * lib/ninetailed/toMemberTrait.ts
 *
 * Pure helper that builds the Ninetailed trait payload from the derived auth
 * state. This is the ONLY place the trait object is constructed, so it acts as
 * a single guard against accidental PII leakage into personalization traits.
 */

export type MemberTrait = {
  isMember: boolean;
};

export function toMemberTrait(isMember: boolean): MemberTrait {
  return { isMember };
}
